<template>
    <div v-if="content" :id="id" class="sub-section">
      <img class="section-image" :src="icon" :alt="alt" />
      <h4>{{ title }}</h4>
      <div v-if="isSkills">
        <div class="skill-collection">
          <img class="skill-image" :alt="skill" v-for="skill in content" :key="skill" :src="'/img/pictogramme/competences/' + skill">
        </div>
      </div>
      <p v-else>{{ content }}</p>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      id: String,
      icon: String,
      alt: String,
      title: String,
      content: [String, Array],
      isSkills: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  

  <style scoped>



.project-details{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5rem 1rem;
}

.grid-section{
  display: grid;
  grid-template-columns:1fr 2fr 1fr;
  grid-template-rows: repeat(3,auto);
  justify-items: center;
  align-items: center;
  width:90%;
  margin:auto;
  row-gap: 5vw;
  column-gap: 5px;
}

.grid-section .sub-section p,h4{
  text-align: center;
  margin-bottom:.5rem;
}

.sub-section{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:1.25rem;
  background: var(--hard-blue);
  padding:1.5rem;
  border-radius: 0;
  box-shadow:var(--box-shadow-1);
  min-width: 30rem;
}

.section-image{
  filter: invert(0.9);
  width:4rem;
}

.skill-collection{
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.skill-collection .skill-image{
  width: 3.75rem;
    height: 3.75rem;
    object-fit: contain;
}

@media (max-width:840px){
.sub-section{
  width: 100% !important;
  margin: auto;
}
.sub-section h4{
  font-size: 3.5rem;
}
.sub-section p{
  font-size: 2.5rem;
}
}

</style>